import { render, staticRenderFns } from "./CampaignInvitation.vue?vue&type=template&id=ae48efee&scoped=true&"
import script from "./CampaignInvitation.vue?vue&type=script&lang=js&"
export * from "./CampaignInvitation.vue?vue&type=script&lang=js&"
import style0 from "./CampaignInvitation.vue?vue&type=style&index=0&id=ae48efee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae48efee",
  null
  
)

export default component.exports